import React from "react"

import ReactMarkdown from "react-markdown"
import remarkMath from "remark-math"
import rehypeKatex from "rehype-katex"
import remarkBreaks from "remark-breaks"
import "katex/dist/katex.min.css"
import "katex/dist/contrib/mhchem"

interface MathTextProps {
  children: string
  className?: string
  inline?: boolean
}

export function MathText({ children, className = "", inline = false }: MathTextProps) {
  // Convert \n to actual line breaks for markdown processing
  const processedText = children.replace(/\\n/g, "\n")

  if (inline) {
    return (
      <span className={className}>
        <ReactMarkdown
          remarkPlugins={[remarkMath, remarkBreaks]}
          rehypePlugins={[rehypeKatex]}
          components={{
            p: ({ children }) => <span>{children}</span>,
            br: () => <br />,
          }}
        >
          {processedText}
        </ReactMarkdown>
      </span>
    )
  }

  return (
    <div className={className}>
      <ReactMarkdown
        remarkPlugins={[remarkMath, remarkBreaks]}
        rehypePlugins={[rehypeKatex]}
        components={{
          // Customize rendering to match our design and handle line breaks
          p: ({ children }) => <p className="mb-2 last:mb-0">{children}</p>,
          br: () => <br />,
          strong: ({ children }) => <strong className="font-semibold">{children}</strong>,
          em: ({ children }) => <em className="italic">{children}</em>,
          code: ({ children }) => <code className="bg-muted px-1 py-0.5 rounded text-sm font-mono">{children}</code>,
          ul: ({ children }) => <ul className="list-disc list-inside mb-2 space-y-1">{children}</ul>,
          ol: ({ children }) => <ol className="list-decimal list-inside mb-2 space-y-1">{children}</ol>,
          li: ({ children }) => <li className="ml-2">{children}</li>,
        }}
      >
        {processedText}
      </ReactMarkdown>
    </div>
  )
}
